import { ApolloProvider } from '@apollo/client';
import { Modal, MortarProvider } from '@policygenius/mortar';
import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router } from 'react-router-dom';

import App from 'App';
import apolloClient from 'graphql/apollo';
import { BASE_PATH } from 'routes/paths';
import reportWebVitals from 'utils/reportWebVitals';

import './index.scss'; // eslint-disable-line import/no-unassigned-import

// https://reactcommunity.org/react-modal/accessibility/#app-element
Modal.setAppElement('#root');

ReactDOM.render(
  <React.StrictMode>
    <ApolloProvider client={apolloClient}>
      <Router basename={BASE_PATH}>
        <MortarProvider>
          <App />
        </MortarProvider>
      </Router>
    </ApolloProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
